<template>
  <div class="frame-modal" @click.self="$emit('close')">
    <div class="modal-template">
      <slot></slot>
      <icon-close @click.native="$emit('close')" :size="20" class="close" />
    </div>
  </div>
</template>

<script>
import iclose from '@/components/icons/close'

export default {
  components: {
    'icon-close': iclose,
  },
}
</script>

<style lang="scss">
.frame-modal {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 1000;
  overflow: hidden;
}
.modal-template {
  position: relative;
  padding: 40px;
  background: #ffffff;
  border: 1px solid #eaeaf5;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  z-index: 1001;
  .close {
    position: absolute;
    top: -30px;
    right: -30px;
    cursor: pointer;
    color: #000;
  }
}
#app[data-theme='dark'] {
  .frame-modal {
    background: #000000;
  }
  .modal-template {
    background: #222222;
    border-color: #333333;
    & > p,
    & > a {
      color: #ffffff;
    }
  }
  .close {
    color: white;
  }
}
</style>
